import axios from "axios";
import { notification } from "antd";
import { UNAUTHORIZED } from "http-status-codes";
import "./responseInterceptor";

const baseURL = process.env.REACT_APP_API_URL;
const webhookUrl =
  "https://hooks.slack.com/services/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";
const rejectResponse = {
  message: "Internet Connection Limited or Disconnected",
};
const slackMessage = (s) => {
  try {
    let data = {
      text:
        "From : Front-End " +
        "\n Name : " +
        s.name +
        "\n ROUTE : " +
        s.config.url +
        "\n Method : " +
        s.config.method +
        "\n Response : " +
        s.response.data.message +
        "\n" +
        s.stack,
    };
    axios.post(webhookUrl, JSON.stringify(data));
  } catch (e) {
  }
};
const networkCheck = new Promise(async (resolve, reject) => {
  if (navigator.onLine) {
    const networkStatus = await fetch("/google.com");
    if (networkStatus.status >= 200 && networkStatus.status < 300) {
      resolve(networkStatus);
    } else {
      reject("Internet Connection Limited or Disconnected");
    }
  } else {
    reject("Internet Connection Limited or Disconnected");
    // alert("Internet Connection Limited or Disconnected");
  }
});

export const doGet = (path) =>
  new Promise((resolve, reject) => {
    if (navigator.onLine) {
      // fetch("/google.com")
      //   .then((result) => {
      //     if (result.status >= 200 && result.status < 300) {
      axios({
        url: path,
        baseURL,
        method: "GET",
        withCredentials: true,
        headers: {
          "access-token": JSON.parse(localStorage.getItem("access-token")),
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          if (String(path).toLowerCase() !== "/users/me") {
            try {
              if (err.response.status === UNAUTHORIZED) {
                // window.location.reload();
              }
            } catch (errorr) {
              slackMessage(errorr);
            }
            reject(err);
            slackMessage(err);
          } else {
            slackMessage(err);
            reject(err);
          }
        });
      // } else {
      //   notification.warning({
      //     message: "Internet Connection Disconnected",
      //     style: {
      //       color: "red",
      //     },
      //   });
      //   reject(rejectResponse);
      // }
      // })
      // .catch((err) => {
      //   notification.warning({
      //     message: "Internet Connection Disconnected",
      //     style: {
      //       color: "red",
      //     },
      //   });
      //   reject(err);
      // });
    } else {
      // alert("Internet Connection Limited or Disconnected");
      notification.warning({
        message: "Internet Connection Disconnected",
        style: {
          color: "red",
        },
      });
      reject(rejectResponse);
    }
  });
export const doPostFormData = (path, data) =>
  new Promise((resolve, reject) => {
    if (navigator.onLine) {
      // fetch("/google.com")
      //   .then((result) => {
      //     if (result.status >= 200 && result.status < 300) {
      axios({
        url: path,
        baseURL,
        method: "POST",
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data,
        headers: {
          "access-token": JSON.parse(localStorage.getItem("access-token")),
        },
      })
        .then((result) => resolve(result))
        .catch((err) => {
          if (String(path).toLowerCase() !== "/users/me") {
            if (err.response.status === UNAUTHORIZED) {
              window.location.reload();
            }
            slackMessage(err);
            reject(err);
          }
        });
      //   } else {
      //     notification.warning({
      //       message: "Internet Connection Disconnected",
      //       style: {
      //         color: "red",
      //       },
      //     });
      //     reject(rejectResponse);
      //   }
      // })
      // .catch((err) => {
      //   notification.warning({
      //     message: "Internet Connection Disconnected",
      //     style: {
      //       color: "red",
      //     },
      //   });
      //   reject(err);
      // });
    } else {
      // alert("Internet Connection Limited or Disconnected");
      notification.warning({
        message: "Internet Connection Disconnected",
        style: {
          color: "red",
        },
      });
      reject(rejectResponse);
    }
  });
// new Promise((resolve, reject) =>
//   axios({
//     url: path,
//     baseURL,
//     method: "POST",
//     withCredentials: true,
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//     data,
//     headers: {
//       "access-token": JSON.parse(localStorage.getItem("access-token")),
//     },
//   })
//     .then((result) => resolve(result))
//     .catch((err) => {
//       if (String(path).toLowerCase() !== "/users/me") {
//         if (err.response.status === UNAUTHORIZED) {
//           window.location.reload();
//         }
//         slackMessage(err);
//         reject(err);
//       }
//     })
// );
export const doPost = (path, data) =>
  new Promise((resolve, reject) => {
    if (navigator.onLine) {
      // fetch("/google.com")
      //   .then((result) => {
      //     if (result.status >= 200 && result.status < 300) {
      axios({
        url: path,
        baseURL,
        method: "POST",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
        data,
        headers: {
          "access-token":
            localStorage.getItem("access-token") != undefined
              ? JSON.parse(localStorage.getItem("access-token"))
              : "",
        },
      })
        .then((result) => resolve(result))
        .catch((err) => {
          if (String(path).toLowerCase() !== "/users/me") {
            if (err.response.status === UNAUTHORIZED) {
              window.location.reload();
            }
            slackMessage(err);
            reject(err);
          }
        });
      //   } else {
      //     notification.warning({
      //       message: "Internet Connection Disconnected",
      //       style: {
      //         color: "red",
      //       },
      //     });
      //     reject(rejectResponse);
      //   }
      // })
      // .catch((err) => {
      //   notification.warning({
      //     message: "Internet Connection Disconnected",
      //     style: {
      //       color: "red",
      //     },
      //   });
      //   reject(err);
      // });
    } else {
      // alert("Internet Connection Limited or Disconnected");
      notification.warning({
        message: "Internet Connection Disconnected",
        style: {
          color: "red",
        },
      });
      reject(rejectResponse);
    }
  });
//   new Promise((resolve, reject) =>
//     axios({
//       url: path,
//       baseURL,
//       method: "POST",
//       withCredentials: true,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data,
//       headers: {
//         "access-token":
//           localStorage.getItem("access-token") != undefined
//             ? JSON.parse(localStorage.getItem("access-token"))
//             : "",
//       },
//     })
//       .then((result) => resolve(result))
//       .catch((err) => {
//         if (String(path).toLowerCase() !== "/users/me") {
//           if (err.response.status === UNAUTHORIZED) {
//             window.location.reload();
//           }
//           slackMessage(err);
//           reject(err);
//         }
//       })
//   );
export const doPut = (path, data) =>
  new Promise((resolve, reject) => {
    if (navigator.onLine) {
      // fetch("/google.com")
      //   .then((result) => {
      //     if (result.status >= 200 && result.status < 300) {
      axios({
        url: path,
        baseURL,
        method: "PUT",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
        data,
        headers: {
          "access-token":
            localStorage.getItem("access-token") != undefined
              ? JSON.parse(localStorage.getItem("access-token"))
              : "",
        },
      })
        .then((result) => resolve(result))
        .catch((err) => {
          if (String(path).toLowerCase() !== "/users/me") {
            if (err.response.status === UNAUTHORIZED) {
              window.location.reload();
            }
            slackMessage(err);
            reject(err);
          }
        });
      //   } else {
      //     notification.warning({
      //       message: "Internet Connection Disconnected",
      //       style: {
      //         color: "red",
      //       },
      //     });
      //     reject(rejectResponse);
      //   }
      // })
      // .catch((err) => {
      //   notification.warning({
      //     message: "Internet Connection Disconnected",
      //     style: {
      //       color: "red",
      //     },
      //   });
      //   reject(err);
      // });
    } else {
      // alert("Internet Connection Limited or Disconnected");
      notification.warning({
        message: "Internet Connection Disconnected",
        style: {
          color: "red",
        },
      });
      reject(rejectResponse);
    }
  });
// new Promise((resolve, reject) =>
//   axios({
//     url: path,
//     baseURL,
//     method: "PUT",
//     withCredentials: true,
//     headers: {
//       "Content-Type": "application/json",
//     },
//     data,
//     headers: {
//       "access-token":
//         localStorage.getItem("access-token") != undefined
//           ? JSON.parse(localStorage.getItem("access-token"))
//           : "",
//     },
//   })
//     .then((result) => resolve(result))
//     .catch((err) => {
//       if (String(path).toLowerCase() !== "/users/me") {
//         if (err.response.status === UNAUTHORIZED) {
//           window.location.reload();
//         }
//         slackMessage(err);
//         reject(err);
//       }
//     })
// );

export const doDelete = (path) =>
  new Promise((resolve, reject) => {
    if (navigator.onLine) {
      // fetch("/google.com")
      //   .then((result) => {
      //     if (result.status >= 200 && result.status < 300) {
      axios({
        url: path,
        baseURL,
        method: "DELETE",
        withCredentials: true,
        headers: {
          "access-token": JSON.parse(localStorage.getItem("access-token")),
        },
      })
        .then((result) => resolve(result))
        .catch((err) => {
          if (String(path).toLowerCase() !== "/users/me") {
            if (err.response.status === UNAUTHORIZED) {
              window.location.reload();
            }
            slackMessage(err);
            reject(err);
          }
        });
      //   } else {
      //     notification.warning({
      //       message: "Internet Connection Disconnected",
      //       style: {
      //         color: "red",
      //       },
      //     });
      //     reject(rejectResponse);
      //   }
      // })
      // .catch((err) => {
      //   notification.warning({
      //     message: "Internet Connection Disconnected",
      //     style: {
      //       color: "red",
      //     },
      //   });
      //   reject(err);
      // });
    } else {
      // alert("Internet Connection Limited or Disconnected");
      notification.warning({
        message: "Internet Connection Disconnected",
        style: {
          color: "red",
        },
      });
      reject(rejectResponse);
    }
  });
// new Promise((resolve, reject) =>
//   axios({
//     url: path,
//     baseURL,
//     method: "DELETE",
//     withCredentials: true,
//     headers: {
//       "access-token": JSON.parse(localStorage.getItem("access-token")),
//     },
//   })
//     .then((result) => resolve(result))
//     .catch((err) => {
//       if (String(path).toLowerCase() !== "/users/me") {
//         if (err.response.status === UNAUTHORIZED) {
//           window.location.reload();
//         }
//         slackMessage(err);
//         reject(err);
//       }
//     })
// );
